import { render, staticRenderFns } from "./NotificationTemplates.vue?vue&type=template&id=7d9bc9d2"
import script from "./NotificationTemplates.vue?vue&type=script&lang=js"
export * from "./NotificationTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports